"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = generateTestId;
/**
 * Generates a test ID string with an optional project prefix.
 *
 * @example
 * const getTestId = generateTestId({ team: 'teamA', project: 'projectX' });
 * const testId = getTestId('my-component'); // Output: "teamA-projectX-my-component"
 *
 * @param {TestIdProviderProps} props - Contains the team and optional project name
 * @returns {(testId: string) => string} A function that returns a formatted test ID string
 */
function generateTestId({
  team,
  project
}) {
  const prefix = `${team}-${project ? `${project}-` : ''}`;

  /**
   * @callback generateTestId~generateTestIdFunction
   * @param {string} testId - component name
   * @returns { string }
   */
  return testId => `${prefix}${testId}`;
}
//# sourceMappingURL=generateTestId.js.map